import apiClient from '../../../shared/services/apiHelper';
import {
 getUserData
} from '../../../shared/utils/authStorage';
export const dashboardService = {
  // Fetch maintenance requests for dashboard
  fetchMaintenanceRequests: async (sort) => {
    const today = new Date().toISOString().split('T')[0];
    try {
      const response = await apiClient.post(`/task/search?sort=${sort}`,
        {
          'scheduled_date': {
          'from': today,
          'to': today,
        },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance requests:', error);
      throw error;
    }
  },

  // Fetch equipment data for dashboard
  fetchEquipment: async (page = 1,) => {
    const user = getUserData();
    const ouId = user?.organization_unit.org_id;
    console.log(`ouid is ${ouId}`);
    try {
      const response = await apiClient.get('/equipment', {ouId:ouId });
      return response.data;
    } catch (error) {
      console.error('Error fetching equipment:', error);
      throw error;
    }
  }
};